import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { orangeMui, rydeColors, ScreenDepth } from "@ryde/theme";

export const RideRowReplacementBoxDragging = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "ride-row-replacement-box-drag",
  },
)`
  position: relative;
  z-index: ${ScreenDepth.DRAG_OVERLAY};
  width: 340px;
  height: 40px;
  padding-inline-start: 20px;
  padding-inline-end: 20px;
  display: flex;
  cursor: pointer;
  gap: 20px;
  align-items: center;
  background-color: ${orangeMui._100};
  border-radius: 3px;
  outline: 2px solid ${rydeColors.dragBorderColor};
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
`;
